import { ApiContractor } from '@allbin/mobilix-api-client';
import { DateTime } from 'luxon';
import { tdUserIdCreator } from './users';

export const tdContractors: ApiContractor[] = [
  {
    id: '41c084fc-c39f-4e85-bd35-9921b5c10cc0',
    name: 'Björnligan tvätt',
    tenant_id: 'vl',
    phone: '+46705055050',
    contact_person: 'Björn Bandhund',
    meta: {
      created_at: DateTime.utc().toISO(),
      created_by: tdUserIdCreator,
      updated_at: DateTime.utc().toISO(),
    },
  },
  {
    id: 'e819f564-d873-4e86-ad91-fdff2b74ee08',
    name: 'Jönsonligan Enterprises Co. Ltd. AB',
    tenant_id: 'vl',
    phone: '+46733233232',
    filterset_id: '41e1315a-68ae-4c01-965f-678d0d2f9d59',
    meta: {
      created_at: DateTime.utc().toISO(),
      created_by: tdUserIdCreator,
      updated_at: DateTime.utc().toISO(),
    },
  },
];
